import React, { useState } from "react";
import { BoardStyles } from "./BoardStyles";

const Board = ({
  isActive,
  overrideStep,
  boardMaterials,
  boardParametters,
  setActiveProduct,
  activeProduct,
  basePrice,
  setOverrideStep,
  setActiveStep,
  setPrice,
  dims,
}) => {
  const handleNextStep = () => {
    setOverrideStep((prev) => prev + 1);
  };
  if (overrideStep == 2) {
    setActiveStep();
  }
  const [state, setState] = useState({
    completedMaterials: false,
    completedParametters: false,
    activeItem: null,
    finisher: null,
    type: null,
    noColors: null,
    weight: null,
    shape: null,
    edge_shape: null,
    cesljano: null,
    isIncreased: false,
    isIncreasedShape: false,
  });
  return (
    isActive && (
      <BoardStyles
        setOverrideStep={setOverrideStep}
        activeStep={overrideStep}
        handleNextStep={handleNextStep}
        boardMaterials={boardMaterials}
        boardParametters={boardParametters}
        setActiveProduct={setActiveProduct}
        activeProduct={activeProduct}
        basePrice={basePrice}
        setPrice={setPrice}
        dims={dims}
        state={state}
        setState={setState}
      />
    )
  );
};

export default Board;
